import styles from "./TextInput.module.css"

const TextInput = ({
    disabled,
    name,
    onChange,
    placeholder,
    readOnly,
    required,
    type,
    value,
    className,
    ...props
}) => {
    return (
        <input type={type} readOnly={readOnly} name={name} onChange={onChange} value={value} disabled={disabled} required={required} placeholder={placeholder} className={[styles.textInput, className].filter(e => !!e).join(' ')} {...props} />
    )
}

export default TextInput;